import { Component } from '@angular/core';

@Component({
  selector: 'app-senior-living',
  templateUrl: './senior-living.component.html',
  styleUrls: ['./senior-living.component.scss']
})
export class SeniorLivingComponent {

}
